<template>
  <div class="add-custom-product">
    <v-dialog
      v-model="dialog"
      content-class="custom-product-dialog"
      transition="dialog-bottom-transition"
      persistent
    >
      <div class="lead-generation-form-container">
        <v-form @submit.prevent ref="addCustomProductRef">
          <div class="heading flex space-between">
            <button class="back flex" @click="dialog = false">
              <v-icon color="#1F8F58" size="20">mdi-arrow-left</v-icon>
            </button>
            <h2 class="--green">{{ heading.text }}</h2>
            <!-- <button class="--green --weight add-from-catalog-btn" @click="$emit('openAddProductModal')"> + Add from Catalog </button> -->
          </div>

          <div class="form-container flex">
            <div class="left-portion">
              <label class="--font"
                >Product name<span style="color: red; margin-left: 2px">
                  *</span
                ></label
              >
              <v-text-field
                v-model="productData.name"
                class="mt-1"
                outlined
                :rules="appliedRules"
                placeholder="Type your product name here.."
              />

              <label class="--font"
                >Category<span style="color: red; margin-left: 2px">
                  *</span
                ></label
              >
              <v-select
                v-model="productData.selectedCategory"
                :items="productCategories.data"
                item-text="name"
                item-value="id"
                class="mt-1"
                outlined
                :loading="categoryLoader"
                :rules="appliedRules"
                placeholder="Choose your product category"
              />

              <label class="--font"
                >Maximum retail price (MRP)<span
                  style="color: red; margin-left: 2px"
                >
                  *</span
                ></label
              >
              <v-text-field
                v-model="productData.price"
                class="mt-1"
                outlined
                :rules="appliedRules"
                placeholder="Enter maximum retail price here"
              />

              <label class="--font"
                >Selling Price<span style="color: red; margin-left: 2px">
                  *</span
                ></label
              >
              <v-text-field
                v-model="productData.sellingPrice"
                class="mt-1"
                outlined
                :rules="appliedRules"
                placeholder="Selling Price"
              />

              <label class="--font"
                >Tax Percentage (0-100)<span style="color: red; margin-left: 2px">
                  *</span
                ></label
              >
              <v-text-field
                v-model="productData.tax"
                class="mt-1"
                outlined
                :rules="appliedRules"
                placeholder="Tax Percentage (0-100)"
              />

              <label class="--font"
                >SKU Size<span style="color: red; margin-left: 2px">
                  *</span
                ></label
              >
              <v-text-field
                v-model="productData.quantity"
                class="mt-1"
                outlined
                :rules="appliedRules"
                placeholder="SKU Size here"
              />

              <label class="--font"
                >Length (in cms)<span style="color: red; margin-left: 2px">
                  *</span
                ></label
              >
              <v-text-field
                v-model="productData.length"
                class="mt-1"
                outlined
                :rules="appliedRules"
                placeholder="Enter length"
              />

              <label class="--font"
                >Breadth (in cms)<span style="color: red; margin-left: 2px">
                  *</span
                ></label
              >
              <v-text-field
                v-model="productData.breadth"
                class="mt-1"
                outlined
                :rules="appliedRules"
                placeholder="Enter breadth"
              />

              <label class="--font"
                >Height (in cms)<span style="color: red; margin-left: 2px">
                  *</span
                ></label
              >
              <v-text-field
                v-model="productData.height"
                class="mt-1"
                outlined
                :rules="appliedRules"
                placeholder="Enter height"
              />

              <label class="--font"
                >Weight (in kg)<span style="color: red; margin-left: 2px">
                  *</span
                ></label
              >
              <v-text-field
                v-model="productData.weight"
                class="mt-1"
                outlined
                :rules="appliedRules"
                placeholder="Enter weight"
              />
              <label class="--font"
                >HSN Code<span style="color: red; margin-left: 2px">
                  *</span
                ></label
              >
              <v-text-field
                class="mt-1"
                v-model="productData.hsn_code"
                outlined
                height="56"
                no-resize
                :rules="appliedRules"
                maxlength="8"
                type="number"
                placeholder="Enter HSN Code"
              />
              <p v-if="hsnCheck" class="hsnErrorText">HSN Code shoud be of 4 to 8 digits</p>

              <label class="--font"
                >Unit type<span style="color: red; margin-left: 2px">
                  *</span
                ></label
              >
              <v-select
                v-model="productData.unitType"
                :items="measuringUnits"
                item-text="name"
                item-value="id"
                class="mt-1"
                outlined
                :loading="categoryLoader"
                :rules="appliedRules"
                placeholder="Choose your product category"
              />

              <!-- <label class="--font">Unit type<span style="color:red;margin-left:2px"> *</span></label>
                        <div class="radio-buttons mb-3">
                            <v-radio-group hide-details class="my-0 radio-group" row v-model="productData.unitType" :rules="appliedRules"> 
                                <v-radio v-for="unit in measuringUnits" 
                                         :key="unit.id" 
                                         :label="unit.name" 
                                         :value="unit.id"
                                         color="#1F8F58"
                                         >
                                </v-radio>
                            </v-radio-group>
                        </div> -->

              <label class="--font"
                >Product availability<span style="color: red; margin-left: 2px">
                  *</span
                ></label
              >
              <div class="radio-buttons mb-3">
                <v-radio-group
                  hide-details
                  row
                  class="my-0"
                  v-model="productData.isGlobal"
                  :rules="appliedRules"
                >
                  <v-radio
                    label="Local sell only"
                    value="false"
                    color="#1F8F58"
                  ></v-radio>
                  <v-radio
                    label="All over India sell"
                    value="true"
                    color="#1F8F58"
                  ></v-radio>
                </v-radio-group>
              </div>

              <label class="--font"
                >Product description<span style="color: red; margin-left: 2px">
                  *</span
                ></label
              >
              <v-textarea
                v-model="productData.description"
                class="mt-1"
                height="80"
                outlined
                :rules="appliedRules"
                placeholder="Write about your product here.."
              />
            </div>

            <div
              class="right-portion"
              @dragenter.prevent="dragEnter"
              @dragleave.prevent="dragLeave"
              @dragover.prevent
              @drop.prevent
            >
              <label class="--font">Upload Product Image</label>
              <input
                type="file"
                id="select-form-image"
                accept="image/*"
                style="display: none"
                @change="selectImage($event, 'select')"
                :disabled="uploadLoader"
              />
              <div class="upload__attach mt-1">
                <label
                  for="select-form-image"
                  class="flex upload-image --green pointer"
                  :class="{ disable: uploadLoader }"
                >
                  <img
                    src="@/assets/MainDashboard/CreateContent/CreatePost/UploadImage.svg"
                    alt=""
                  />
                  Upload Product Image
                  <v-progress-circular
                    indeterminate
                    size="15"
                    width="2"
                    class="mx-2"
                    v-if="uploadLoader"
                  />
                </label>
              </div>

              <div
                class="flex drop-zone"
                @drop.prevent="selectImage($event, 'drag')"
              >
                <p>Or drag and drop your files here</p>
                <div class="images-preview-container flex">
                  <div v-if="uploadedImage.length">
                    <img
                      class="preview-image"
                      :src="
                        uploadedImage.length
                          ? uploadedImage[0].image.original
                          : ''
                      "
                      alt=""
                    />
                    <v-icon
                      class="delete-image pointer"
                      color="white"
                      size="18"
                      @click.native="$store.state.mainStore.uploadedImages = []"
                    >
                      mdi-close
                    </v-icon>
                  </div>
                </div>
              </div>

              <!-- <div class="buttons flex">
                            <button class="--green --weight discard" v-ripple @click="$emit('close')">Discard</button>
                            <button v-if="heading.type === 'create'" 
                                    class="green-background white--text --weight submit-button" 
                                    v-ripple  
                                    @click="createACustomProduct"
                                    :disabled="uploadLoader">
                                Upload product
                            </button>
                            <button v-else class="green-background white--text --weight submit-button" v-ripple  @click="editProduct" :disabled="uploadLoader">
                                Edit product
                            </button>
                        </div> -->
            </div>
          </div>
          <div class="buttons flex">
            <button
              class="--green --weight discard"
              v-ripple
              @click="$emit('close')"
            >
              Discard
            </button>
            <button
              v-if="heading.type === 'create'"
              class="green-background white--text --weight submit-button"
              v-ripple
              @click="createACustomProduct"
              :disabled="uploadLoader"
            >
              Upload product
            </button>
            <button
              v-else
              class="green-background white--text --weight submit-button"
              v-ripple
              @click="editProduct"
              :disabled="uploadLoader"
            >
              Edit product
            </button>
          </div>

          <v-progress-linear
            indeterminate
            class="mt-2"
            color="#1F8F58"
            v-if="loader"
          ></v-progress-linear>
        </v-form>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import accessToken from "../../../../helpers/accessToken";
import rules from "../../../../helpers/rules";
import API_URL from "../../../../helpers/apiUrls";

export default {
  name: "addCustomProduct",

  data() {
    return {
      productData: {
        name: "",
        heading: "",
        description: "",
        selectedCategory: null,
        price: null,
        quantity: null,
        unitType: null,
        isGlobal: null,
        images: [],
        discount: null,
        sellingPrice: null,
        tax: null,
        length: null,
        breadth: null,
        height: null,
        weight: null,
        hsn_code: null,
      },
      tax: null,
      image: null,
      rules: rules,
      appliedRules: [],
      loader: false,
      measuringUnits: [],
      categoryLoader: false,
      rules: rules,
      appliedRules: [],
      heading: {
        text: "Create New Product",
        type: "create",
      },
      productIDToEdit: null,
      uploadLoader: false,
      hsnCheck:false,
    };
  },

  computed: {
    productCategories() {
      return this.$store.getters["productsStore/GET_PRODUCT_CATEGORIES"];
    },

    uploadedImage() {
      return this.$store.getters["mainStore/GET_UPLOADED_IMAGES"];
    },

    getDiscount() {
      let dis = (
        ((this.productData.price - this.productData.sellingPrice) * 100) /
        this.productData.price
      ).toFixed();
      if (dis >= 0) {
        return dis;
      } else {
        this.productData.sellingPrice = this.productData.price;
        return 0;
      }
    },

    imageUploadStatus() {
      return this.$store.getters["mainStore/GET_IMAGE_UPLOAD_STATUS"];
    },
  },

  props: {
    dialog: {
      type: Boolean,
    },
  },

  watch: {
    dialog: function (value) {
      if (!value) {
        (this.productData = {
          name: "",
          heading: "",
          description: "",
          selectedCategory: null,
          price: null,
          quantity: null,
          unitType: null,
          isGlobal: null,
          images: [],
          discount: null,
          sellingPrice: null,
          tax: null,
          length: null,
          breadth: null,
          height: null,
          weight: null,
          hsn_code: null,
        }),
          (this.loader = false);
        this.heading = {
          text: "Create New Product",
          type: "create",
        };
        this.uploadLoader = false;
        this.$store.state.mainStore.uploadedImages = [];
        this.$refs.addCustomProductRef.reset();
        this.$router.go();
      } else {
        this.getProductCategories();
        this.getMeasuringUnits();
      }
    },

    "productCategories.data": function (newValue) {
      if (newValue.length) {
        this.categoryLoader = false;
      }
    },
    "productData.hsn_code": function (newValue) {
      if (newValue.length > 8) {
        this.hsnCheck = true;
      }
      else this.hsnCheck = false;

    },

    uploadedImage: function (value) {
      if (value.length) this.uploadLoader = false;
    },

    imageUploadStatus: function (value) {
      if (value) this.uploadLoader = false;
    },
  },

  methods: {
    dragEnter() {
      this.isDragged = true;
    },

    dragLeave() {
      this.isDragged = false;
    },

    selectImage(event, type = "select") {
      if (type === "drag") this.image = event.dataTransfer.files[0];
      else this.image = event.target.files[0];
      this.uploadLoader = true;
      this.$store.dispatch("mainStore/imageUpload", this.image);
      // this.imagePreview = helper.provideImagePreviewURL([this.image])[0];
      event.target.value = "";
    },

    getProductCategories() {
      this.categoryLoader = true;
      this.$store.dispatch("productsStore/getProductCategories");
    },

    getMeasuringUnits() {
      const successHandler = (response) => {
        if (response.status === 200) {
          this.measuringUnits = response.data.measuring_unit;
        }
      };

      const errorHandler = (error) => {
        this.showToast("Something went wrong internally!", "error", 10000);
        console.log(error);
      };

      const headers = {
        Authorization: `Bearer ${accessToken.getAccessToken()}`,
      };

      this.requestGET(
        API_URL.products__measuringUnits,
        {},
        headers,
        successHandler,
        errorHandler
      );
    },

    createACustomProduct() {
      if (
        parseInt(this.productData.sellingPrice) >
        parseInt(this.productData.price)
      ) {
        this.showToast("Selling Price should be less than MRP", "error");
        return;
      }
      if (parseInt(this.productData.tax) > 100) {
        this.showToast("Tax should be between 0-100", "error");
        return;
      }
      if ( this.productData.hsn_code && this.productData.hsn_code.length < 4 ) {
        this.showToast("HSN code should be of 4 to 8 digits", "error");
        return;
      }

      this.appliedRules.push(this.rules.required);
      if (this.$refs.addCustomProductRef.validate()) {
        this.loader = true;
        const successHandler = (response) => {
          if (response.status === 201) {
            this.loader = false;
            this.showToast("A product has been successfully added!");
            this.$emit("close");
            this.$emit("refresh");
          }
        };

        const errorHandler = (error) => {
          this.showToast("Something went wrong internally!", "error", 10000);
          console.log(error);
        };

        const data = {
          product_name: this.productData.name,
          category: this.productData.selectedCategory,
          maximum_retail_price: this.productData.price,
          product_size: this.productData.quantity,
          measuring_unit: this.productData.unitType,
          is_global: this.productData.isGlobal === "true" ? true : false,
          product_description: this.productData.description,
          selling_price: this.productData.sellingPrice,
          discount_percentage: this.getDiscount,
          tax_percentage: this.productData.tax ? this.productData.tax : null,
          length: this.productData.length,
          breadth: this.productData.breadth,
          height: this.productData.height,
          weight: this.productData.weight,
          hsn_code: this.productData.hsn_code,
        };

        // if(this.productData.tax){
        //     data.tax_percentage=this.productData.tax;
        // }

        if (this.uploadedImage.length)
          data["images"] = [{ image_id: this.uploadedImage[0].id, order: 0 }];

        const headers = {
          Authorization: `Bearer ${accessToken.getAccessToken()}`,
        };

        this.requestPOST(
          API_URL.products__historicalProducts,
          data,
          headers,
          successHandler,
          errorHandler
        );
      }
    },

    editProduct() {
      if (
        parseInt(this.productData.sellingPrice) >
        parseInt(this.productData.price)
      ) {
        this.showToast("Selling Price should be less than MRP", "error");
        return;
      }
      if (parseInt(this.productData.tax) > 100) {
        this.showToast("Tax should be between 0-100", "error");
        return;
      }
      if (this.productData.hsn_code && this.productData.hsn_code.length < 4 ) {
        this.showToast("HSN code should be of 4 to 8 digits", "error");
        return;
      }
      this.appliedRules.push(this.rules.required);
      if (this.$refs.addCustomProductRef.validate()) {
        this.loader = true;
        const successHandler = (response) => {
          if (response.status === 200) {
            this.loader = false;
            this.showToast("A product has been successfully updated!");
            this.$emit("close");
            this.$emit("refresh");
          }
          console.log(this.productData.tax_percentage);
        };

        const errorHandler = (error) => {
          this.showToast("Something went wrong internally!", "error", 10000);
          console.log(error);
        };

        const data = {
          product_name: this.productData.name,
          category: this.productData.selectedCategory,
          maximum_retail_price: this.productData.price,
          product_size: this.productData.quantity,
          measuring_unit: this.productData.unitType,
          is_global: this.productData.isGlobal,
          product_description: this.productData.description,
          discount_percentage: this.getDiscount,
          selling_price: this.productData.sellingPrice,
          tax_percentage: this.productData.tax ? this.productData.tax : null,
          length: this.productData.length,
          breadth: this.productData.breadth,
          height: this.productData.height,
          weight: this.productData.weight,
          hsn_code: this.productData.hsn_code,
        };
        //  if(this.productData.tax){
        //     data.tax_percentage=this.productData.tax;
        // }

        if (this.uploadedImage.length)
          data["images"] = [{ image_id: this.uploadedImage[0].id, order: 0 }];

        const headers = {
          Authorization: `Bearer ${accessToken.getAccessToken()}`,
        };

        this.requestPATCH(
          `${API_URL.products__historicalProducts}/${this.productIDToEdit}`,
          data,
          headers,
          successHandler,
          errorHandler
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.lead-generation-form-container {
  padding: 10px 20px 20px 20px;
  height: 600px;
}

.back {
  width: 40px;
  height: 40px;
  border-radius: 7px;
  margin-right: 35px;
  background: rgba(49, 138, 54, 0.05);
}
.heading {
  display: flex;
  justify-content: flex-start;
  padding-top: 10px;
  background-color: white;
}

.add-from-catalog-btn {
  background: #eff6f3;
  border-radius: 7px;
  padding: 10px;
}

.form-container {
  margin-top: 30px;
  justify-content: space-between;
  align-items: flex-start;
  height: 420px;
}
.hsnErrorText{
  font-size:12px;
  color: red;
  margin:0px;
  transform: translateY(-23px);
}

.left-portion {
  width: 48%;
  height: 100%;
  overflow-y: scroll;
}

.right-portion {
  width: 48%;
  position: sticky;
  top: 60px;
  height: 100%;
}

.buttons {
  justify-content: space-between;
  padding-top: 20px;
  background-color: white;
  gap: 15px;
}

.discard {
  background: #eff6f3;
  width: 29%;
}

.buttons button:not(.discard) {
  width: 50%;
  box-shadow: 1px 3px 3px rgba(46, 73, 50, 0.25);
  height: 50px;
}

.buttons button {
  border-radius: 5px;
  height: 50px;
  width: 50%;
}

label {
  font-size: 0.9rem;
}

.upload__attach label {
  border-radius: 5px;
  padding: 13px;
  font-size: 0.9rem;
}

.upload__attach label img {
  margin-right: 15px;
}

.upload-image {
  background: rgba(87, 215, 192, 0.05);
  width: 100%;
}

.drop-zone {
  flex-direction: column;
  background: #fbfdfc;
  border: 1px dashed #dbdbdb;
  border-radius: 7px;
  margin: 20px 0;
  padding: 140px 0;
  color: #c2cbc3;
  position: relative;

  p {
    margin: 0;
  }
}

.images-preview-container {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.images-preview-container > div {
  width: 120px;
  height: 120px;
  border-radius: 3px;
  margin: 0 5px;
}

.preview-image {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.delete-image {
  background-color: rgba(53, 52, 52, 0.47);
  border-radius: 50%;
  transform: translate(97px, -125px);
}

.disable {
  opacity: 0.5;
  cursor: unset;
}

.submit-button:disabled {
  opacity: 0.5;
}
</style>

<style lang="scss">
.custom-product-dialog.v-dialog {
  width: 60%;
  background-color: white;
}

.form-selection-box fieldset {
  color: white !important;
}

.form-selection-box .mdi::before {
  color: var(--primary-color) !important;
}

.form-selection-box input::placeholder {
  color: var(--primary-color) !important;
  opacity: 1;
  font-size: 0.9rem;
}

.radio-group .v-input--radio-group__input {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

@media all and (min-width: 1500px) {
  .custom-product-dialog.v-dialog {
    width: 50%;
  }
}
</style>